import { render, staticRenderFns } from "./AppReleaseStats.vue?vue&type=template&id=05321ffb&scoped=true"
import script from "./AppReleaseStats.vue?vue&type=script&lang=js"
export * from "./AppReleaseStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05321ffb",
  null
  
)

export default component.exports